module.exports = __webpack_public_path__ + "2dfc85d82023858410059e8c569a9b0d.png";